import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  protected config = environment;

  constructor() {
    console.log('constructor del ConfigurationService');
  }

  //get logLevel(): LOG_LEVEL {
  //  return this.config.log_level;
  //}
}
